import "react-app-polyfill/stable";
import "./polyfill";

import "whatwg-fetch";
import "chart.piecelabel.js";

import React from "react";
import ReactDOM from "react-dom";
import ReactSelect from "react-select";
import AsyncSelect from "react-select/async";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import es from "date-fns/locale/es";
// 
import App from "./App";
// import config from "./config/auth";
import history from "@dhn/shared/history";
// import installSmoothHeight from "@dhn/shared/smooth-height";
import Auth0Provider from "@dhn/components/contexts/react-auth0-spa";

import * as serviceWorker from "./serviceWorker";
import "react-datepicker/dist/react-datepicker.css";
// import Ver from "./config/auth";


const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

const auth0Audience = (process.env.REACT_APP_AUTH0_AUDIENCE || "").trim();
const FLOATING_CONTROL_Z_INDEX = 1080;

// AsyncSelect busca mientras se escribe, por eso su texto guía dice "Buscar".
const configureSelectMenu = (SelectComponent, placeholder) => {
  SelectComponent.defaultProps = {
    ...(SelectComponent.defaultProps || {}),
    classNamePrefix: "dhn-select",
    placeholder,
    menuPortalTarget: document.body,
    menuPosition: "fixed",
    styles: {
      ...(SelectComponent.defaultProps?.styles || {}),
      menuPortal: (base) => ({ ...base, zIndex: FLOATING_CONTROL_Z_INDEX }),
    },
  };
};

configureSelectMenu(ReactSelect, "Seleccionar...");
configureSelectMenu(AsyncSelect, "Buscar...");

// Todos los DatePicker muestran meses y días en español.
registerLocale("es", es);
setDefaultLocale("es");

// El calendario se dibuja sobre la página (portal) para que tablas y tarjetas con
// overflow no lo corten, y las fechas se muestran como día/mes/año cuando la pantalla
// no indica otro formato. defaultProps es un getter en react-datepicker, por eso se redefine.
const datePickerDefaults = DatePicker.defaultProps;
Object.defineProperty(DatePicker, "defaultProps", {
  configurable: true,
  get: () => ({
    ...datePickerDefaults,
    dateFormat: "dd/MM/yyyy",
    portalId: "dhn-datepicker-portal",
  }),
});

// Desactivado: el MutationObserver global fuerza un reflow en cada cambio del DOM
// y fija el alto de las tarjetas con overflow oculto; en producción congelaba la
// navegación y montaba controles uno encima de otro.
// installSmoothHeight();

ReactDOM.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    audience={auth0Audience || undefined}
    client_id={process.env.REACT_APP_AUTH0_CLIENT_ID}
    redirect_uri={window.location.origin}
    cacheLocation="localstorage"
    ui_locales="es"
    onRedirectCallback={onRedirectCallback}
  >
    <App />
  </Auth0Provider>,
  document.getElementById("root")
);

window.addEventListener('beforeunload', function(event) {
  // localStorage.removeItem('datos')
  localStorage.removeItem('rnc');
  localStorage.removeItem('ars');
  localStorage.removeItem('mes');
  localStorage.removeItem('rncFormat');
  sessionStorage.removeItem('recoverData');
});


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
